import session from "./session";
import i18n from "./i18n";
import passwordPolicy from "./password-policy";
import statements from "./statements";
import drawer from "./drawer";
import profile from "./profile";
import application from "./application";
import documentPromptStore from "./fields/documentPromptStore";
import readOnlyFieldStore from "./fields/readOnlyFieldStore";
import simpleFieldStore from "./fields/simpleFieldStore";
import statementPromptStore from "./fields/statementPromptStore";
import specialFieldStore from "./fields/specialFieldStore";
import template from "./template";
import apiKeys from "./api-keys";
import purchase from "./purchase";
import bnplPurchase from "./bnplPurchase";
import deal from "./deal";
import users from "./user";
import applicationAdmin from "./application-admin";
import bnplApplication from "./bnplApplicaton";
import offerDocGeneration from "./offer-doc-generation";
import bnplApplicationSignatureStore from "./bnpl-application-signature";
import bnplInStoreApplication from "./bnpl-in-store-application";
import calculation from "./calculation";
import offer from "./offer";
import image from "./image";
import limit from "./limit";
import customer from "./customer";
import dashboard from "./dashboard";
import payee from "./payee";
import bnplB2bApplication from "./bnplB2bApplicaton";
import onboarding from "./onboarding";
import uiConfigStore from "./ui-config";
import customerLimit from "./customer-limit";

/**
 * Gathering all modules to export into the Vuex Store
 */
export default {
  session,
  i18n,
  passwordPolicy,
  statements,
  drawer,
  profile,
  application,
  documentPromptStore,
  readOnlyFieldStore,
  simpleFieldStore,
  statementPromptStore,
  specialFieldStore,
  template,
  apiKeys,
  purchase,
  bnplPurchase,
  bnplInStoreApplication,
  bnplApplication,
  bnplApplicationSignatureStore,
  image,
  deal,
  users,
  applicationAdmin,
  calculation,
  offer,
  offerDocGeneration,
  limit,
  customer,
  dashboard,
  payee,
  bnplB2bApplication,
  onboarding,
  uiConfigStore,
  customerLimit,
};
